export default {
  option: provided => ({
    ...provided,
    padding: 10,
  }),
  control: provided => ({
    ...provided,
    minWidth: 100,
    minHeight: 15,
    padding: 0,
    marginTop: '-3px',
  }),
  dropdownIndicator: provided => ({
    ...provided,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  clearIndicator: provided => ({
    ...provided,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  menu: provided => ({
    ...provided,
    paddingTop: 0,
    top: '80%'
  }),
  valueContainer: provided => ({
    ...provided,
    // padding: 3
  })
};
